"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cdDrawLine = exports.cdDrawCurve = exports.cdDrawBezier = void 0;
var curve_1 = require("../../curve");
var polygon_1 = require("../../polygon");
var util_1 = require("../../util");
function cdDrawCurveU(font, polygons, x1, y1, sx1, sy1, sx2, sy2, x2, y2, ta1, ta2) {
    var a1 = ta1;
    var a2 = ta2;
    var delta1 = 0;
    switch (a1 % 10) {
        case 2:
            delta1 = font.kWidth;
            break;
        case 3:
            delta1 = font.kWidth * font.kKakato;
            break;
    }
    if (delta1 !== 0) {
        var _a = (x1 === sx1 && y1 === sy1)
            ? [0, delta1] // ?????
            : util_1.normalize([x1 - sx1, y1 - sy1], delta1), dx1 = _a[0], dy1 = _a[1];
        x1 += dx1;
        y1 += dy1;
    }
    var delta2 = 0;
    switch (a2 % 10) {
        case 2:
            delta2 = font.kWidth;
            break;
        case 3:
            delta2 = font.kWidth * font.kKakato;
            break;
    }
    if (delta2 !== 0) {
        var _b = (sx2 === x2 && sy2 === y2)
            ? [0, -delta2] // ?????
            : util_1.normalize([x2 - sx2, y2 - sy2], delta2), dx2 = _b[0], dy2 = _b[1];
        x2 += dx2;
        y2 += dy2;
    }
    var _c = curve_1.generateFattenCurve(x1, y1, sx1, sy1, sx2, sy2, x2, y2, font.kRate, function () { return font.kWidth; }, function (_a, mag) {
        var x = _a[0], y = _a[1];
        return (util_1.round(x) === 0 && util_1.round(y) === 0)
            ? [-mag, 0] // ?????
            : util_1.normalize([x, y], mag);
    }), left = _c.left, right = _c.right;
    var poly = new polygon_1.Polygon();
    var poly2 = new polygon_1.Polygon();
    // save to polygon
    for (var _i = 0, left_1 = left; _i < left_1.length; _i++) {
        var _d = left_1[_i], x = _d[0], y = _d[1];
        poly.push(x, y);
    }
    for (var _e = 0, right_1 = right; _e < right_1.length; _e++) {
        var _f = right_1[_e], x = _f[0], y = _f[1];
        poly2.push(x, y);
    }
    poly2.reverse();
    poly.concat(poly2);
    polygons.push(poly);
}
function cdDrawBezier(font, polygons, x1, y1, x2, y2, x3, y3, x4, y4, a1, a2) {
    cdDrawCurveU(font, polygons, x1, y1, x2, y2, x3, y3, x4, y4, a1, a2);
}
exports.cdDrawBezier = cdDrawBezier;
function cdDrawCurve(font, polygons, x1, y1, x2, y2, x3, y3, a1, a2) {
    cdDrawCurveU(font, polygons, x1, y1, x2, y2, x2, y2, x3, y3, a1, a2);
}
exports.cdDrawCurve = cdDrawCurve;
function cdDrawLine(font, polygons, tx1, ty1, tx2, ty2, ta1, ta2) {
    var x1;
    var y1;
    var x2;
    var y2;
    var a1;
    var a2;
    if (tx1 === tx2 && ty1 > ty2 || tx1 > tx2) {
        x1 = tx2;
        y1 = ty2;
        x2 = tx1;
        y2 = ty1;
        a1 = ta2;
        a2 = ta1;
    }
    else {
        x1 = tx1;
        y1 = ty1;
        x2 = tx2;
        y2 = ty2;
        a1 = ta1;
        a2 = ta2;
    }
    var _a = (x1 === x2 && y1 === y2)
        ? [0, 1] // ?????
        : util_1.normalize([x2 - x1, y2 - y1]), dx = _a[0], dy = _a[1];
    var delta1 = 0;
    switch (a1 % 10) {
        case 2:
            delta1 = font.kWidth;
            break;
        case 3:
            delta1 = font.kWidth * font.kKakato;
            break;
    }
    if (delta1 !== 0) {
        x1 -= dx * delta1;
        y1 -= dy * delta1;
    }
    var delta2 = 0;
    switch (a2 % 10) {
        case 2:
            delta2 = font.kWidth;
            break;
        case 3:
            delta2 = font.kWidth * font.kKakato;
            break;
    }
    if (delta2 !== 0) {
        x2 += dx * delta2;
        y2 += dy * delta2;
    }
    // SUICHOKU NO ICHI ZURASHI HA Math.sin TO Math.cos NO IREKAE + x-axis MAINASU KA
    var poly = new polygon_1.Polygon([
        { x: x1 + dy * font.kWidth, y: y1 - dx * font.kWidth },
        { x: x2 + dy * font.kWidth, y: y2 - dx * font.kWidth },
        { x: x2 - dy * font.kWidth, y: y2 + dx * font.kWidth },
        { x: x1 - dy * font.kWidth, y: y1 + dx * font.kWidth },
    ]);
    if (tx1 === tx2) {
        poly.reverse(); // ?????
    }
    polygons.push(poly);
}
exports.cdDrawLine = cdDrawLine;
